// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IGroupingRecordInfoDto } from './IGroupingRecordInfoDto';
import {
    IGroupingRecordInfoDtoFromJSON,
    IGroupingRecordInfoDtoFromJSONTyped,
    IGroupingRecordInfoDtoToJSON,
    IGroupingRecordInfoDtoToJSONTyped,
} from './IGroupingRecordInfoDto';

/**
 * 
 * @export
 * @interface IContributionSearchResponseInfoDto
 */
export interface IContributionSearchResponseInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IContributionSearchResponseInfoDto
     */
    contribution_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionSearchResponseInfoDto
     */
    request_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IContributionSearchResponseInfoDto
     */
    submit_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IContributionSearchResponseInfoDto
     */
    contribution_source?: IContributionSearchResponseInfoDtoContributionSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof IContributionSearchResponseInfoDto
     */
    status?: IContributionSearchResponseInfoDtoStatusEnum;
    /**
     * 
     * @type {Array<IGroupingRecordInfoDto>}
     * @memberof IContributionSearchResponseInfoDto
     */
    records_group?: Array<IGroupingRecordInfoDto>;
    /**
     * 
     * @type {number}
     * @memberof IContributionSearchResponseInfoDto
     */
    record_count?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionSearchResponseInfoDto
     */
    payroll_calendar_name?: string;
}

/**
* @export
* @enum {string}
*/
export enum IContributionSearchResponseInfoDtoContributionSourceEnum {
    FPS = 'FPS',
    API = 'API',
    UI = 'UI',
    RECURRING = 'RECURRING',
    SCHEDULED = 'SCHEDULED'
}
/**
* @export
* @enum {string}
*/
export enum IContributionSearchResponseInfoDtoStatusEnum {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
    ERROR = 'ERROR',
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    APPROVAL_NEEDED = 'APPROVAL_NEEDED',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED'
}


/**
 * Check if a given object implements the IContributionSearchResponseInfoDto interface.
 */
export function instanceOfIContributionSearchResponseInfoDto(value: object): value is IContributionSearchResponseInfoDto {
    return true;
}

export function IContributionSearchResponseInfoDtoFromJSON(json: any): IContributionSearchResponseInfoDto {
    return IContributionSearchResponseInfoDtoFromJSONTyped(json, false);
}

export function IContributionSearchResponseInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionSearchResponseInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_id': json['contribution_id'] == null ? undefined : json['contribution_id'],
        'request_id': json['request_id'] == null ? undefined : json['request_id'],
        'submit_date': json['submit_date'] == null ? undefined : (new Date(json['submit_date'])),
        'contribution_source': json['contribution_source'] == null ? undefined : json['contribution_source'],
        'status': json['status'] == null ? undefined : json['status'],
        'records_group': json['records_group'] == null ? undefined : ((json['records_group'] as Array<any>).map(IGroupingRecordInfoDtoFromJSON)),
        'record_count': json['record_count'] == null ? undefined : json['record_count'],
        'payroll_calendar_name': json['payroll_calendar_name'] == null ? undefined : json['payroll_calendar_name'],
    };
}

export function IContributionSearchResponseInfoDtoToJSON(json: any): IContributionSearchResponseInfoDto {
    return IContributionSearchResponseInfoDtoToJSONTyped(json, false);
}

export function IContributionSearchResponseInfoDtoToJSONTyped(value?: IContributionSearchResponseInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_id': value['contribution_id'],
        'request_id': value['request_id'],
        'submit_date': value['submit_date'] == null ? undefined : ((value['submit_date']).toISOString().substring(0,10)),
        'contribution_source': value['contribution_source'],
        'status': value['status'],
        'records_group': value['records_group'] == null ? undefined : ((value['records_group'] as Array<any>).map(IGroupingRecordInfoDtoToJSON)),
        'record_count': value['record_count'],
        'payroll_calendar_name': value['payroll_calendar_name'],
    };
}

